import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { cloneDeep } from 'lodash-es'

export function createDirectory(body, params) {
  return request.post(ApiAddress.PROJECT_DIRECTORIES, body, { params })
}

export async function getFileTree(params): Promise<any[]> {
  return request.get(ApiAddress.PROJECT_FILES_TREE, { params })
}

export function updateDirectoryOrFile(body, params) {
  return request.put(ApiAddress.PROJECT_DIRECTORY_FILE, body, { params })
}

export function deleteDirectoryOrFile(id) {
  return request.delete(ApiAddress.DIRECTORY_FILE, { params: { id } })
}

export function fileListToTree(files) {
  let map = {}
  let roots: any[] = []
  const list = cloneDeep(files)

  list.forEach((item, index) => {
    map[item.id] = index
    if (!item.file) {
      item.children = []
    }
  })

  list.forEach((item) => {
    if (item.dirId) {
      list[map[item.dirId]].children.push(item)
    } else {
      roots.push(item)
    }
  })

  return roots
}

export function treeToList(tree) {
  const list: any[] = []
  const expaned = (data) => {
    data.forEach((item) => {
      list.push(item)
      expaned(item.file || [])
    })
  }
  expaned(tree)
  return list
}
